const PaymentStatus = {
    CASHED:    'Cashed',
    PROCESSED: 'Processed',
    SWEPT:     'Swept',
    COMPLETED: 'Completed',
    ISSUED:    'Issued',
    ATTEMPTED: 'Attempted',
    VOIDED:    'Voided',
    VOID:      'Void',
    FAILED:    'Failed',
};

export const COMPLETED_STATUSES = [
    PaymentStatus.CASHED,
    PaymentStatus.PROCESSED,
    PaymentStatus.SWEPT,
    PaymentStatus.COMPLETED,
];

export default PaymentStatus;
